import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const AvisoLegal = () => {
  return (
    <div className="py-16 relative">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8 text-center">Aviso Legal</h1>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Información General</h2>
            <p className="text-gray-700 mb-4">
              En cumplimiento con el deber de información dispuesto en la Ley 34/2002 de Servicios de la Sociedad de la Información y el Comercio Electrónico (LSSI-CE) de 11 de julio, se facilitan a continuación los siguientes datos de información general de este sitio web.
            </p>
            <p className="text-gray-700">
              La titularidad de este sitio web corresponde a:
            </p>
            <ul className="list-disc ml-6 mt-2 mb-4 text-gray-700">
              <li>Nombre: VGBComputers</li>
              <li>Dirección: <a 
                  href="https://maps.app.goo.gl/jT6LFzR59caoLysh7" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  C.C. Nuestra Señora de África, Local 64 - Santa Cruz de Tenerife
                </a>
              </li>
              <li>Contacto: <a href="mailto:info@vgbcomputers.com" className="text-blue-600 hover:underline">info@vgbcomputers.com</a></li>
              <li>Teléfono: <a href="tel:+34922640256" className="text-blue-600 hover:underline">+34 922 640 256</a></li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Términos y Condiciones de Uso</h2>
            <p className="text-gray-700 mb-4">
              El acceso a este sitio web implica la aceptación expresa por parte del usuario de estos términos y condiciones de uso, que podrán ser modificados o sustituidos por su titular en cualquier momento y sin previo aviso.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Responsabilidades</h2>
            <p className="text-gray-700 mb-4">
              El titular no se hace responsable de la información y contenidos almacenados en foros, redes sociales o cualquier otro medio que permita a terceros publicar contenidos de forma independiente en esta web.
            </p>
            <p className="text-gray-700 mb-4">
              Sin embargo, en cumplimiento de lo dispuesto en la LSSI-CE, se pone a disposición de todos los usuarios, autoridades y fuerzas de seguridad, colaborando de forma activa en la retirada o, en su caso, bloqueo de todos aquellos contenidos que puedan afectar o contravenir la legislación nacional o internacional, los derechos de terceros o la moral y el orden público.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Propiedad Intelectual e Industrial</h2>
            <p className="text-gray-700 mb-4">
              Los derechos de propiedad intelectual e industrial derivados de todos los textos, imágenes, así como de los medios y formas de presentación y montaje de esta web, pertenecen a su titular o a terceros que han autorizado su uso.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Legislación Aplicable y Jurisdicción</h2>
            <p className="text-gray-700">
              La relación entre el titular y el usuario se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y Tribunales de Santa Cruz de Tenerife.
            </p>
          </div>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default AvisoLegal;